import {
  Grid,
  makeStyles,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  Theme,
  TableContainer,
} from "@material-ui/core";
import React, { FunctionComponent, useContext } from "react";
import { useTranslation } from "react-i18next";
import { EventType, RouteStop } from "../../../api/nachfahrbarkeit-api/generated";
import { ContentContainer } from "../../../components/content-container/content-container";
import { Text } from "../../../components/text/text";
import { RouteContext } from "./route-context";

const useStyles = makeStyles((theme: Theme) => ({
  idColumn: {
    width: 40,
  },
  deleteColumn: {
    width: 40,
    borderRight: "none",
  },
  editColumn: {
    width: 40,
  },
  lastRow: {
    borderBottom: "none",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
  },
}));

interface IRouteDetailsTableProps {}

export const RouteDetailsTable: FunctionComponent<IRouteDetailsTableProps> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { route } = useContext(RouteContext);
  const stopCount = route ? route?.stops.length : 0;

  const sortAndFilterStops = (stops: RouteStop[]) => {
    const filtered = stops.filter(
      (stop) => stop.events && stop.events.some((event) => event.event_type === EventType.bulk && event.info),
    );
    const sorted = filtered.sort((a, b) => a.sequence_number - b.sequence_number);
    return sorted;
  };

  const getStopRelevantEventInfos = (stop: RouteStop) => {
    const relevantInfos = stop.events
      ?.filter((event) => event.event_type === EventType.bulk && event.info)
      .map((event) => event.info as string);

    return relevantInfos ? relevantInfos.join(", ") : t("routes_management.erros.no_relevant_info");
  };

  return (
    <Grid container direction="column" spacing={2}>
      <Grid>
        <Grid item>
          <ContentContainer>
            <TableContainer style={{ maxHeight: 400 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">{t("routes_management.table.sequence_number")}</TableCell>
                    <TableCell align="center">{t("routes_management.table.lat")}</TableCell>
                    <TableCell align="center">{t("routes_management.table.long")}</TableCell>
                    <TableCell align="center">{t("routes_management.table.info")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {route &&
                    sortAndFilterStops(route.stops).map((stop, index) => (
                      <TableRow key={stop.id}>
                        <TableCell align="center" className={index === stopCount - 1 ? classes.lastRow : undefined}>
                          {stop.sequence_number}
                        </TableCell>
                        <TableCell align="center" className={index === stopCount - 1 ? classes.lastRow : undefined}>
                          {stop.latitude}
                        </TableCell>
                        <TableCell align="center" className={index === stopCount - 1 ? classes.lastRow : undefined}>
                          {stop.longitude}
                        </TableCell>
                        <TableCell align="center" className={index === stopCount - 1 ? classes.lastRow : undefined}>
                          {getStopRelevantEventInfos(stop)}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              {route?.stops && route.stops.length <= 0 && (
                <Grid container item style={{ height: "20vh" }} justify={"center"} alignContent={"center"}>
                  <Text color="textSecondary">{t("routes_management.table.empty")}</Text>
                </Grid>
              )}
            </TableContainer>
          </ContentContainer>
        </Grid>
      </Grid>
    </Grid>
  );
};
